/**
 * Replays the add-to-cart character's arrival on every add to cart.
 *
 * This exists because CSS alone cannot do it. Dawn's cart notification only
 * re-renders three regions — cart-notification-product,
 * cart-notification-button and cart-icon-bubble — and the character sits in
 * the heading, outside all of them. So the element persists for the life of
 * the page. Dawn's open() then calls classList.add('active'), which changes
 * nothing when the notification is already open, so an animation keyed to
 * that class plays once per page and never again. Adding a second item
 * without dismissing the first would be silent.
 *
 * Restarting an animation requires removing the class, forcing a reflow so
 * the browser registers the change, then adding it back.
 *
 * Nothing here touches the cart. The character is a non-interactive, inert
 * element outside every region Dawn replaces, so this cannot interfere with
 * the DOM swap that actually delivers the cart update.
 */

(() => {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  const replay = () => {
    const mascot = document.querySelector('#cart-notification .cart-mascot');
    if (!mascot) return;

    mascot.classList.remove('cart-mascot--arrive');
    // Forces a reflow. Without it the browser coalesces the remove and add
    // into no change at all, and the animation does not restart.
    //
    // Must be getBoundingClientRect(), not offsetWidth. offsetWidth is an
    // HTMLElement property and the honey crock is an inlined <svg>, i.e. an
    // SVGElement — reading offsetWidth there is simply undefined, forces no
    // layout, and the animation silently never replays. That was measured,
    // not assumed. getBoundingClientRect() exists on both, so this works for
    // the crock and for the product image alike.
    void mascot.getBoundingClientRect().width;
    mascot.classList.add('cart-mascot--arrive');
  };

  subscribe(PUB_SUB_EVENTS.cartUpdate, replay);
})();
